import {ReactComponent as Logo} from "../../../assets/images/logo.svg";

const LogoComponent = ({height=18}) => {
  return <Logo fill={"var(--gray900"} height={height}/>
}
export default LogoComponent;